import React from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Send, Loader2, Paperclip } from "lucide-react";
import { DOC_ACCEPT } from "@shared/consultation/ConsultationDocuments";
import { ComposerAttachments } from "@shared/consultation/ComposerAttachments";

// Bottom composer: queued attachments strip + attach / text / send controls. Upload & send logic lives in the room.
export function Composer({ pending, onRemove, onRetry, sending, fileInputRef, onPickFile, input, onTyping, onSend, onPaste, isLive, isLawyerSide }) {
  const sendable = pending.some((p) => p.status === "queued" || (p.status === "error" && !p.fatal));
  return (
    <div className="box-border w-full max-w-full min-w-0 shrink-0 border-t border-slate-100 p-3 md:p-4 bg-white" data-testid="consult-composer">
      <ComposerAttachments items={pending} onRemove={onRemove} onRetry={onRetry} sending={sending} />
      <div className="flex w-full max-w-full min-w-0 items-end gap-2">
        <input ref={fileInputRef} type="file" multiple accept={DOC_ACCEPT} className="hidden" onChange={onPickFile} data-testid="consult-attach-input" />
        <Button type="button" variant="outline" onClick={() => fileInputRef.current?.click()} disabled={sending}
          data-testid="consult-attach-btn" title="Attach documents (PDF, image, DOC — up to 10 MB each) · or paste / drop files" className="relative rounded-xl h-11 w-11 p-0 shrink-0">
          <Paperclip size={16} />
          {pending.length > 0 && (
            <span className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] px-1 rounded-full bg-[#D4AF37] text-[#0A2540] text-[10px] font-extrabold grid place-items-center" data-testid="consult-attach-count">{pending.length}</span>
          )}
        </Button>
        <Textarea
          value={input}
          onChange={(e) => onTyping(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); onSend(); } }}
          onPaste={onPaste}
          placeholder={isLive ? (pending.length ? "Add a message (optional)…" : "Type a message…") : (isLawyerSide ? "Start the consultation to chat" : "Waiting for the lawyer to start…")}
          data-testid="consult-input"
          rows={1}
          disabled={!isLive}
          className="box-border min-h-[44px] max-h-[120px] min-w-0 flex-1 basis-0 resize-none rounded-xl"
        />
        <Button onClick={onSend} disabled={sending || pending.some((p) => p.status === "preparing") || !((input.trim() && isLive) || sendable)}
          data-testid="consult-send-btn" aria-busy={sending} className="h-11 w-11 shrink-0 rounded-xl p-0 adv-btn-primary">
          {sending ? <Loader2 size={16} className="animate-spin" data-testid="consult-sending" /> : <Send size={16} />}
        </Button>
      </div>
    </div>
  );
}
